module.exports = __webpack_public_path__ + "static/coinbase_commerce_api_key-78d68f7b9d5e7f69102087d60e661be5.png";